module.exports = __webpack_public_path__ + "img/shopTalkLogo.68d9bef2.png";